import { accordion } from '../accordion/accordion';

export function init() {
	Array.from(document.querySelectorAll('.js-filters')).forEach(element => {
		accordion(element.id).init();
	});
}
